module.exports = __webpack_public_path__ + "static/img/right-top-row-6.bc52e473.webp";